export type base32guid = string;
